import cn from 'classnames';
import React from 'react';

import style from './Section.module.scss';

interface IPropsSection extends React.HTMLAttributes<any> {
  inversion?: boolean;
}

export const Section = (props: IPropsSection): React.ReactElement => {
  const { className, inversion, ...restProps } = props;
  return <tr className={cn(className, style.section, { [style.inversion]: inversion })} {...restProps} />;
};
